import React, { memo, useContext } from 'react';
import { NodeBox } from '../../components/NodeBox';
import { ResourceName } from '../../components/ResourceName';
import { ChipWithCopy } from 'new/elements/ChipWithCopy';
import { Button } from 'new/elements/Button';
import { ResourceEditContext } from 'js/components/ResourceEditProvider/ResourceEditContext';
import { RESOURCE_TYPE_DATA_SET } from 'js/constants/resourceTypes';
import styles from './SuccessModifier.module.scss';

interface SuccessModifierProps {
  data: any;
  isPreview?: boolean;
}

export const SuccessModifier = memo((props: SuccessModifierProps) => {
  const { data, isPreview } = props;
  const { setAction } = useContext(ResourceEditContext);

  const handleConfigureClick = () => {
    setAction({
      resource: RESOURCE_TYPE_DATA_SET,
      type: (data?.id ? 'edit' : 'create') as 'edit' | 'create',
      id: data?.id,
    });
  };

  return (
    <NodeBox data={data} className={styles.container}>
      <ResourceName {...props}>Transform</ResourceName>
      <div className={styles.modifierContainer}>
        <NodeBox.Title>{data?.name}</NodeBox.Title>
      </div>
      <NodeBox.Footer className={styles.transformFooter}>
        <div className={styles.bottomActions}>
          <ChipWithCopy tooltipTitle="Copy Transform ID" toCopy={data?.id}>
            ID {data?.id}
          </ChipWithCopy>
          {!isPreview && (
            <Button
              variant="outlined"
              color="primary"
              className={styles.configureButton}
              onClick={handleConfigureClick}
            >
              Configure
            </Button>
          )}
        </div>
      </NodeBox.Footer>
    </NodeBox>
  );
});
